import { render, staticRenderFns } from "./TaxonLink.vue?vue&type=template&id=8c5523fc"
import script from "./TaxonLink.vue?vue&type=script&lang=js"
export * from "./TaxonLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports